import { render } from "./ContactModal.vue?vue&type=template&id=b146e820&scoped=true"
import script from "./ContactModal.vue?vue&type=script&lang=js"
export * from "./ContactModal.vue?vue&type=script&lang=js"

import "./ContactModal.vue?vue&type=style&index=0&id=b146e820&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b146e820"

export default script